import React from "react";

var PaperAirplaneIcon = function PaperAirplaneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23.207.408a1.977 1.977 0 0 0-2.159-.161L1.038 11.161A1.971 1.971 0 0 0 0 12.881a1.97 1.97 0 0 0 .983 1.75l4.724 2.779 11.292-9.409L8 19v5l3.837-2.984 4.607 2.71a2.002 2.002 0 0 0 1.803.111 2 2 0 0 0 1.155-1.39L23.949 2.44a1.971 1.971 0 0 0-.742-2.032z"
  }));
};

PaperAirplaneIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
PaperAirplaneIcon.defaultProps.solid = true;
export default PaperAirplaneIcon;